export const STATUS_CODE_400 = 400;
export const MEETING_NAME_EXISTS = 'DisplayNameExistError';
export const EXTENSION_NOT_FOUND = 'EXTENSION_NOT_FOUND';
export const GENERIC_MEETING_ERROR = 'GENERIC_MEETING_ERROR';
